import { Paper, PaperProps, ThemeProvider, useTheme } from "@mui/material";

export const VbPaper = (props: PaperProps) => {
    const theme = useTheme();

    return (
        <ThemeProvider theme={theme}>
            <Paper
                {...props}
                elevation={8}
                sx={{
                    p: '18px',
                    backgroundImage: 'none',
                    backgroundColor: 'var(--background-secondary)',
                    borderRadius: '16px',
                    boxShadow: `0px 2px 20px rgba(44, 44, 44, 0.15)`
                }}
            />
        </ThemeProvider>
    )
}
